<template>
    <section>
        <div class="content-section content-section__centered">
            <prismic-rich-text :field="slice.primary.text" />
        </div>
    </section>
</template>
<script>
    export default {
        props: ['slice'],
        name: 'textcentered'
    }
</script>
<style lang="scss">
    .content-section {
        &__centered {
            max-width: 58.33333%;
            margin: 0 auto 5rem;
            text-align: center;
            @media (max-width: 768px) {
                max-width: 100%;
                padding: 0 0 30px;
            }
            & h2 {
                font-size: 1.6em;
                line-height: 1.3;
                color: #555555;
            }
        }
    }
</style>
